import { MAX_NOTE_LENGTH } from '@constants/notesAttachment';
import * as yup from 'yup';

function note(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'NOTE_IS_REQUIRED',
        defaultMessage: 'Note is required',
      }),
    )
    .max(
      MAX_NOTE_LENGTH,
      formatMessage(
        {
          id: 'NOTE_CANNOT_BE_MORE_THAN_LENGTH_CHARACTERS',
          defaultMessage: `Note cannot be more than {length} characters`,
        },
        {
          length: MAX_NOTE_LENGTH,
        },
      ),
    );
}

function files(formatMessage) {
  return yup.array().of(
    yup.object({
      attachmentType: yup.string().required(
        formatMessage({
          id: 'ATTACHMENT_TYPE_IS_REQUIRED',
          defaultMessage: 'Attachment type is required',
        }),
      ),
      description: yup.string().when('attachmentType', {
        is: 'OTHER',
        then: s => s.required('Description is required'),
      }),
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      note: note(formatMessage),
      files: files(formatMessage),
    })
    .required();

export default validationSchema;
